export const REGEXES = {
  HAS_LETTERS_ONLY: /^[a-zA-Z]+$/,
  HAS_LETTERS_WITH_HYPHEN_SPACE: /^[a-zA-Z -]+$/,
  HAS_SPECIAL_CHAR: /[`!@#$%^&*()_+\=\[\]{};':"\\|.<>\/?~]/,
  IS_NUMBERS_ONLY: /^\d+$/,
  PHONE_NUMBER: /^(\+\d{1,2}\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};
